/* eslint-disable */
<template>
  <div class="user-setting">
    <Navigation indexProps="guides"/>
    <div class="top-panel">
      <Header/>
      <div class="header-title-section">
        <div class="header-title"><h1>{{ title }}</h1></div>
      </div>
    </div>
    <div class="panel">
      <ClientGuidesMenu :indexProps="index"/>
      <div class="content">
        <iframe v-show="frameSrc" :src="frameSrc" style="width: 100%; height: 100vh">
          <!--        <pdf-->
          <!--            v-for="i in numPages"-->
          <!--            :key="i"-->
          <!--            :src="src"-->
          <!--            :page="i"-->
          <!--            style="width: 70%"-->
          <!--        ></pdf>-->
        </iframe>
      </div>
    </div>
    <Chat/>
  </div>
</template>

<script>
import utilities from '@/assets/js/utilities'
import Navigation from '@/components/Navigation'
import Header from '@/components/Header'
import Chat from '@/components/Chat'
import ClientGuidesMenu from '@/components/ClientGuidesMenu'

export default {
  name: 'UserSetting',
  components: {
    Navigation,
    Header,
    Chat,
    ClientGuidesMenu
  },
  data() {
    return {
      loading: false,
      src: null,
      numPages: undefined,
      index: 0,
      title: '',
      frameSrc: ''
    }
  },
  methods: {
    async tapUpdate() {
      utilities.showAlert(".alert-warning", false)
    }
  },
  async mounted() {
    this.$store.dispatch('loading/setLoadComponent', true)
    this.index = this.$route.query.index
    if (this.index === '0') {
      this.src = "RHO How To - Schedule a New Booking v1.html";
      this.title = 'How to schedule a new booking'
    } else if (this.index === '1') {
      this.src = "RHO How To - Reschedule a Booking v1.html";
      this.title = 'How to reschedule a booking'
    } else if (this.index === '2') {
      this.title = 'How to update a booking'
      this.src = "RHO How To - Update a Booking v1.html";
    } else if (this.index === '3') {
      this.title = 'How to cancel a booking'
      this.src = "RHO How To - Cancel a Booking v1.1.html";
    }
    this.frameSrc = await utilities.getDownloadHowToUrlNew({
      FileName: this.src
    })
    this.$store.dispatch('loading/setLoadComponent', false)
  },
}
</script>
